import { Controller } from '@hotwired/stimulus'

export default class ProductDescriptionController extends Controller {
  static targets = ['content', 'button']

  declare readonly contentTarget: HTMLElement
  declare readonly buttonTarget: HTMLButtonElement

  toggle() {
    const isExpanded =
      this.contentTarget.getAttribute('data-expanded') === 'true'

    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    const scrollHeight = this.contentTarget.scrollHeight
    this.contentTarget.style.height = `${this.contentTarget.offsetHeight}px`

    // Force reflow
    this.contentTarget.offsetHeight

    this.contentTarget.classList.remove('h-30', 'md:h-34')
    this.contentTarget.classList.add('h-auto')
    this.contentTarget.classList.remove('mask-fade-bottom')
    this.contentTarget.style.height = `${scrollHeight}px`

    this.contentTarget.addEventListener(
      'transitionend',
      () => {
        this.contentTarget.style.height = ''
        this.contentTarget.classList.remove('overflow-hidden')
      },
      { once: true },
    )

    this.contentTarget.setAttribute('data-expanded', 'true')
    this.buttonTarget.textContent = 'Less'
  }

  collapse() {
    this.contentTarget.classList.add('overflow-hidden')
    this.contentTarget.classList.remove('h-auto')
    this.contentTarget.classList.add('mask-fade-bottom')
    this.contentTarget.style.height = `${this.contentTarget.offsetHeight}px`

    // Force reflow
    this.contentTarget.offsetHeight

    this.contentTarget.classList.add('h-30', 'md:h-34')
    this.contentTarget.style.height = ''

    this.contentTarget.setAttribute('data-expanded', 'false')
    this.buttonTarget.textContent = 'More'
  }
}
